import Notiflix from 'notiflix';
import React, { createContext, useEffect, useState } from 'react'
import { getUser } from '../data/api/auth/AuthRoutes';
import validErrors from '../hooks/validErrors';

const IndexContext = createContext();

const IndexProvider = ({children}) => {

    Notiflix.Notify.init({timeout: 5000, position: 'right-bottom'});
    Notiflix.Report.init({success: {backOverlayColor: 'rgba(0,0,0,0.5)'}});

    const [auth, setAuth] = useState();
    const [loading, setLoading] = useState(true);
    const [token, setToken] = useState(localStorage.getItem('AUTH_TOKEN') || sessionStorage.getItem('AUTH_TOKEN'));

    useEffect(() => {
        if (token) {
            setLoading(true);
            // No usamos try/catch sync alrededor de una promesa async —
            // no atrapa nada. validateUser() ya captura sus propios
            // errores adentro, así que basta con encadenar finally
            // para bajar el loading.
            validateUser().finally(() => setLoading(false));
        }
    }, []);

    const validateUser = async () => {
        // No-op si no hay sesión (ej: flujo de donación anónima). Sin esto,
        // se enviaría "Authorization: Bearer null" al backend y devolvería 401.
        if (!token) return;
        try {
            const { data } = await getUser(token);
            setAuth(data);
        } catch (error) {
            // Caso típico: token expirado → 401. El interceptor global
            // de clientAxios ya muestra el alert "Sesión expirada" y
            // limpia el storage; no hace falta hacer ruido acá. Sin
            // este try/catch, la rejection burbujea como "Uncaught
            // runtime error" y aparece el overlay rojo de React-DOM
            // en desarrollo.
            if (error?.response?.status !== 401) {
                validErrors(error);
            }
        }
    }

    return (
        <IndexContext.Provider
            value={{
                auth,
                setAuth,
                loading,
                setLoading,
                token,
                setToken,
                validateUser
            }}
        >
            {children}
        </IndexContext.Provider>
    )
}

export {
    IndexProvider
}

export default IndexContext;